import { render, staticRenderFns } from "./viewDiagnosis.vue?vue&type=template&id=bd682aaa&scoped=true&"
import script from "./viewDiagnosis.vue?vue&type=script&lang=js&"
export * from "./viewDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./viewDiagnosis.vue?vue&type=style&index=0&id=bd682aaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd682aaa",
  null
  
)

export default component.exports